'use client'

import { SiteShell } from '@/components/site/site-shell'
import { PageIntro } from '@/components/site/page-intro'
import { CapabilityList } from '@/components/site/capability-list'
import { ServicePackages } from '@/components/site/service-packages'
import { MagneticLink } from '@/components/site/magnetic-button'
import { RevealText } from '@/components/site/reveal-text'
import { FaqList } from '@/components/site/faq-list'
import { serviceFaqs } from '@/content/faq'
import { FaqJsonLd } from '@/seo/FaqJsonLd'

export default function ServicesPage() {
  return (
    <SiteShell>
      <FaqJsonLd faqs={serviceFaqs} />
      <div className="w-full bg-background px-6 pb-20 pt-24 md:pb-32 lg:px-12">
        <div className="mx-auto max-w-7xl">
          <PageIntro
            eyebrow="Services"
            title={
              <>
                Built for teams
                <br />
                <span className="italic text-muted-foreground">that need to ship.</span>
              </>
            }
            description="Marketing sites, custom software, and ongoing optimization - scoped and documented so small teams get clarity, not vendor soup."
          />

          <RevealText className="mb-8">
            <span className="text-xs tracking-[0.3em] uppercase text-accent">Capabilities</span>
          </RevealText>
          <CapabilityList />

          <ServicePackages id="packages" />

          <div className="mt-16 flex flex-wrap gap-4 text-sm uppercase tracking-[0.15em]">
            <MagneticLink href="/services/web-design" variant="outline">
              Web design
            </MagneticLink>
            <MagneticLink href="/services/custom-software" variant="outline">
              Custom software
            </MagneticLink>
            <MagneticLink href="/services/graphic-design" variant="outline">
              Brand & graphic
            </MagneticLink>
          </div>

          <FaqList faqs={serviceFaqs} />

          <div className="mt-20 border-t border-border pt-16 text-center md:mt-24">
            <RevealText>
              <p className="mb-8 font-serif text-2xl italic text-muted-foreground md:text-3xl">
                Ready to start a project?
              </p>
            </RevealText>
            <MagneticLink href="/contact" variant="primary">
              Get in touch
            </MagneticLink>
          </div>
        </div>
      </div>
    </SiteShell>
  )
}
